import React from "react";
import { Formik, Form } from "formik";
import capitalize from "lodash/capitalize";
import { FormikFormGroup, ModalSubmit } from "components/common";
import { Modal, Row, Col } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
const CloudStorageRepositoryModalForm = ({ type, hideModal }) => {
  const { onCreateRepository } = useRepositories();
  const handleSubmit = (values) => {
    const { bucket, container, ...baseValues } = values;
    const submitValues = {
      type,
      ...baseValues,
      ...bucket && { bucket },
      ...container && { container }
    };
    return onCreateRepository(submitValues).then(() => hideModal());
  };
  const commonValues = {
    name: "",
    base_path: ""
  };
  const bucketLabel = type === "azure" ? "container" : "bucket";
  const initialValues = { ...commonValues, [bucketLabel]: "" };
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit: handleSubmit, initialValues }, ({ isSubmitting, isValidating }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: "Name",
      name: "name",
      help: "Name of your warm storage repository. Must be unique.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: capitalize(bucketLabel),
      name: bucketLabel,
      help: `Name the warm storage repository ${bucketLabel}`,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: "Base Path",
      name: "base_path",
      help: "Base path of the warm storage repository",
      required: true
    }
  )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: "Create",
      submitLoadingText: "Creating...",
      onCancel: hideModal,
      disabledSubmit: isValidating,
      isSubmitting
    }
  ))));
};
export default CloudStorageRepositoryModalForm;
